// 知情同意条款池：生成交付链接时每条都是一个 tickbox，勾选想展示的条款。
// 存储格式为编号 CSV（如 "1,3,4"）；一条都不勾选则存 "none"。
// kind: "intro" 不编号的引言段落 / "term" 编号条款 / "social" 社交媒体卡片。
export const CONSENT_CLAUSES = [
    { id: 1, kind: "intro", key: "thanks" },
    { id: 2, kind: "intro", key: "sponsorIntro" },
    { id: 3, kind: "term", key: "expiry" },
    { id: 4, kind: "term", key: "commercial" },
    { id: 5, kind: "term", key: "copyright" },
    { id: 6, kind: "term", key: "colorGrading" },
    { id: 7, kind: "term", key: "shooting" },
    { id: 8, kind: "social", key: "social" },
];

// 选片专属条款池：在交付通用条款基础上补充选片成片质量说明。
export const SELECTION_CONSENT_CLAUSES = [
    ...CONSENT_CLAUSES.filter((clause) => clause.kind !== "social"),
    { id: 9, kind: "term", key: "selectionQuality" },
    ...CONSENT_CLAUSES.filter((clause) => clause.kind === "social"),
];

// 历史 variant -> 条款编号，保证旧链接/旧数据仍能正确展示。
const LEGACY = {
    general: [1, 3, 4, 5, 8],
    g: [1, 3, 4, 5, 8],
    sponsor: [2, 3, 6, 7, 8],
    s: [2, 3, 6, 7, 8],
    none: [],
    n: [],
};

function orderIds(ids, clauses = CONSENT_CLAUSES) {
    const allIds = clauses.map((clause) => clause.id);
    const picked = new Set(ids);
    return allIds.filter((id) => picked.has(id));
}

// 解析存储值 / payload 值为有序、去重、合法的条款编号数组。
// 数组按字面处理（空数组 = 不展示）；缺省（null/undefined/空串）按历史默认 general 处理。
export function parseConsentClauseIds(value, clauses = CONSENT_CLAUSES) {
    const validIds = new Set(clauses.map((clause) => clause.id));
    if (Array.isArray(value)) {
        return orderIds(value.map((n) => Number(n)).filter((n) => validIds.has(n)), clauses);
    }
    if (value == null) {
        return LEGACY.general.slice();
    }
    const str = String(value).trim();
    if (!str) {
        return LEGACY.general.slice();
    }
    if (Object.prototype.hasOwnProperty.call(LEGACY, str)) {
        return LEGACY[str].slice();
    }
    const ids = str
        .split(",")
        .map((part) => parseInt(part.trim(), 10))
        .filter((n) => validIds.has(n));
    return orderIds(ids, clauses);
}

// 条款编号数组 -> 存储字符串；为空则 "none"。
export function stringifyConsentClauseIds(ids, clauses = CONSENT_CLAUSES) {
    const validIds = new Set(clauses.map((clause) => clause.id));
    const ordered = orderIds(
        (Array.isArray(ids) ? ids : [])
            .map((n) => Number(n))
            .filter((n) => validIds.has(n)),
        clauses
    );
    return ordered.length ? ordered.join(",") : "none";
}

export function parseSelectionConsentClauseIds(value) {
    return parseConsentClauseIds(value, SELECTION_CONSENT_CLAUSES);
}

export function stringifySelectionConsentClauseIds(ids) {
    return stringifyConsentClauseIds(ids, SELECTION_CONSENT_CLAUSES);
}

export function getClauseById(id) {
    return CONSENT_CLAUSES.find((clause) => clause.id === id) || null;
}
